import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { RestDataService } from '../../service/rest-data.service';
import { Config } from '../../config/config';
import { StaticDataService } from '../../service/static-data.service';
import { PageListingComponent } from '../page-listing/page-listing.component';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import * as dragula from 'dragula';
import { DragulaService } from 'ng2-dragula';

@Component({
  selector: '.app-zone-listing',
  templateUrl: './zone-listing.component.html',
  styleUrls: ['./zone-listing.component.css']
})
export class ZoneListingComponent implements OnInit {

  @Input() collectionList: any[];
  @Input() limit: number;
  @Input() elementsToExclude: any[];

  tempArray = [];
  tempData = {};
  cricketindex = 0;
  indexDrop = 0;
  matchPopup = false;
  arrayList: any[] = [];
  elementid: string;
  @Output() selectionCompleted = new EventEmitter<any>();
  @Output() closeSelection = new EventEmitter<any>();
  @ViewChild('colList',{static: false}) colList: PageListingComponent;


  constructor(
    private restService: RestDataService,
    private config: Config,
    private snotify: SnotifyService,
    private dragulaService: DragulaService,
    private sharedService: SharedDataService
  ) {
    const bag: any = dragulaService.find('another-bag');
    if (bag === undefined) {
      dragulaService.setOptions('another-bag', {
        copy: function (el, source) {
          return source.id === 'left';
        },
        accepts: function (el, target, source, sibling) {
          return target.id !== 'left';
        },
        moves: function (el: any, container: any, handle: any): any {
          return (el.className !== 'ex-over-opac');
        },
        copySortSource: false
      });
    }
    dragulaService.dropModel.subscribe((value) => {
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });

  }

  ngOnInit() {
    // this.tempArray = JSON.parse(JSON.stringify(this.collectionList));
    this.getAllCollectionData(this.collectionList);
  }
  private onRemoveModel(args) {
    const [el, target, source] = args;
  }
  getPopupValueToParentfn(obj) {
    this.matchPopup = obj;
  }
  onDrop(args) {
    const [el, target, source, e] = args;
    if (e != null) {
      this.indexDrop = +e.value;
    }
  }
  private onDropModel(args) {
    const [el, target, source, targetModel] = args;
    if (source.id === 'right') {
      this.tempArray = [];
      for (let i = 0; i < this.arrayList.length; i++) {
        if (this.arrayList[i] !== null) {
          this.tempArray.push(this.arrayList[i].id);
        }
      }
      // this.selectionCompleted.emit(this.tempArray);
    } else {
      const index = this.tempArray.indexOf(+el.id);

      if (index < 0) {
        if (el.title === 'cricket') {
          this.cricketindex = this.arrayList.indexOf(+el.id);
          this.matchPopup = true;
          //this.listArray = [];
        } else {
        this.tempArray = [];
        for (let i = 0; i < this.arrayList.length; i++) {
          if (this.arrayList[i] !== null) {
            this.tempArray.push(this.arrayList[i].id);
          }
        }}
      } else {
        this.arrayList = this.arrayList.filter(i => i.id !== +el.id);
        this.tempArray = [];
        for (let i = 0; i < this.arrayList.length; i++) {
          if (this.arrayList[i] !== null) {
            this.tempArray.push(this.arrayList[i].id);
          }
        }
        this.tempArray.splice(this.indexDrop, 0, +el.id);
      }
    }
    this.getAllCollectionData(this.tempArray);
    setTimeout(e => {
      this.colList.isInArray = this.elementsToExclude.concat(this.tempArray);
    }, 50);


  }
  getAllCollectionData(obj) {
    if (obj && obj.length > 0) {
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.story_page_id, StaticDataService.element_byids_api),
        obj,
        res => {
          this.arrayList = [];
          this.arrayList = res;
          this.tempArray = [];
          for (let i = 0; i < this.arrayList.length; i++) {
            if (this.arrayList[i] !== null) {
              this.tempArray.push(this.arrayList[i].id);
            }
          }
        });
    }
  }

  idSelectionChange(data) {
    const index = this.tempArray.indexOf(data.id);
    console.log(this.tempArray, this.arrayList);
    if ((index > -1)) {
      this.tempArray.splice(index, 1);
      this.arrayList.splice(index, 1);
    } else {
      if (this.tempArray.length < this.limit) {
        this.tempArray.push(data.id);
        this.tempData[data.id] = data;
      } else {
        this.snotify.info('You cannot add more Collection in this zone', '', this.sharedService.getConfig(false));
      }
    }

    if (this.elementsToExclude.indexOf(data.id) > -1) {
      this.elementsToExclude.splice(this.elementsToExclude.indexOf(data.id), 1);
    }
    setTimeout(e => {
      this.colList.isInArray = this.elementsToExclude.concat(this.tempArray);
    }, 50);
  }

  finishSelection() {
    this.selectionCompleted.emit(this.tempArray);
    this.closePopup();
  }

  closePopup() {
    this.closeSelection.emit();
  }


  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(new RegExp('<em>', 'g'), '~@em@~').replace(new RegExp('</em>', 'g'), '~@/em@~')
        .replace(/<[^>]+>/gm, '')
        .replace(new RegExp('~@em@~', 'g'), '<em>').replace(new RegExp('~@/em@~', 'g'), '</em>').trim() : '';
    } else {
      return text;
    }
  }
  getNewTypeVersionDate(datestring) {
    const dt = new Date(datestring.replace('+0000', 'Z'));
    return this.getDate(Math.round(dt.getTime()));
  }
  getDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  open_new(ur) {
    if (ur) {
      window.open(window.location.origin + ur, '_blank');
    }
  }

  @HostListener('keydown', ['$event'])
  public hotkeys($event) {
    const key = $event.keyCode || $event.charCode;
    console.log(key);
    if (key === 27) {
      this.closePopup();
    }
  }
  getMatchDetailsToParentfn(obj) {
    if (obj) {
      const cricketCard = JSON.parse(JSON.stringify(StaticDataService.defaultCricketCardData));
      cricketCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      cricketCard.match = obj;
      cricketCard.name = obj.matchNameWithDate;
      cricketCard.title = obj.matchNameWithDate;
      this.matchPopup = false;
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        cricketCard, result => {
          this.elementid = result.id;
          if (this.elementid) {
          this.tempArray.splice(1, 0, this.elementid);
          this.selectionCompleted.emit(this.tempArray);
          this.getAllCollectionData(this.tempArray);
          setTimeout(e => {
            this.colList.isInArray = this.elementsToExclude.concat(this.tempArray);
          }, 50);
          result.metadata.status = 'PUBLISHED';
          this.restService.http_put(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'save_element')
          + '/' + String(this.elementid),
          this.sharedService.checkhrefandreplace(result),
          result1 => {});
        }
      });
    } else {
      this.snotify.error('Select a Option', '', this.sharedService.getConfig(false));
    }
  }

}
